// @flow
import {connect} from 'react-redux';
import config from '../../../config';
import {addOptionToNewOffer} from '../../../modules/NewOffer/actions';
import {
  getRoamingCreditableOptionsWithPlanWithZeroValues,
  newOfferOptionsSelector,
} from '../../../modules/NewOffer/selectors';
import {getRoamingCreditableOptionsWithPlan} from '../../../modules/AvailableOption/selectors';
import RoamingPlanSliders from './RoamingPlanSliders';

const mapStateToProps = state => ({
  selectedOptions: newOfferOptionsSelector(state),
  creditableOptions: config.addZeroOptionForEachService
    ? getRoamingCreditableOptionsWithPlanWithZeroValues(state)
    : getRoamingCreditableOptionsWithPlan(state),
  priceKey: 'taxIncludedAmount',
});

const mapDispatchToProps = {
  addOptionToNewOffer,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoamingPlanSliders);
